<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    max-width="600px"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>ที่อยู่ร้านค้า</strong>
      </v-card-title>

      <v-card-text style="max-height: 90%;">
        <v-row row wrap class="map-layout">
          <v-col class="pa-0 mt-8">
            <v-row>
              <v-col>
                <gmap-autocomplete
                  class="box-input"
                  :country="['th']"
                  :value="description"
                  placeholder="This is a placeholder text"
                  @place_changed="setPlace"
                  :select-first-on-enter="true"
                ></gmap-autocomplete>
              </v-col>
            </v-row>
            <div style="position: relative">
              <div class="overlay-marker">
                <v-icon x-large color="primary">fas fa-map-marker-alt</v-icon>
              </div>
              <gmap-map
                :center="mapCenter"
                :zoom="16"
                :options="mapConfig"
                ref="map"
                map-type-id="roadmap"
                @center_changed="updateCenter"
                @idle="syncMap"
                style="height: 450px"
                class="map-container"
              ></gmap-map>
            </div>
          </v-col>
        </v-row>
        <v-row row wrap>
          <v-col class="px-4">
            <el-form label-position="left" label-width="100px" @submit.native.prevent>
              <p>{{form.address}} &middot; ({{form.lat | numFormat('0,0.00000')}}, {{form.lng | numFormat('0,0.00000')}})</p>
              <el-form-item label="ชื่อสถานที่">
                <el-input v-model="form.label"></el-input>
              </el-form-item>
              <el-form-item label="ชั้น, ห้อง">
                <el-input v-model="form.floor"></el-input>
              </el-form-item>
              <el-form-item label="ข้อความ">
                <el-input v-model="form.remark"></el-input>
              </el-form-item>
            </el-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
        <v-btn color="primary" depressed @click="save()">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "address-dialog",
  props: {
    showDialog: { default: false },
  },
  data() {
    return {
      form: {
        label: "",
        place_detail: "",
        place_name: "",
        place_id: "",
        lat: 13.736717,
        lng: 100.523186,
        remark: "",
      },
      description: "",
      reportedMapCenter: {
        lat: 13.736717,
        lng: 100.523186,
      },
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186,
      },
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  created() {
    //this.syncMap();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save", this.form);
    },
    updateCenter(latLng) {
      this.form.lat = latLng.lat();
      this.form.lng = latLng.lng();
    },
    syncMap() {
      this.reportedMapCenter = {
        lat: this.form.lat,
        lng: this.form.lng,
      };

      this.mapCenter = this.reportedMapCenter;

      let geoCoder = new google.maps.Geocoder();

      geoCoder.geocode(
        { location: this.reportedMapCenter },
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.setPlace(results[0], false);
            }
          }
        }
      );
    },
    setPlace(place, setLatLng = true) {
      if (!place) return;

      this.description = place.formatted_address;

      // Set center
      if (setLatLng) {
        this.mapCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        this.reportedMapCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
      }

      // Find postal code
      place.address_components.find((address) => {
        if (address.types[0] === "postal_code") {
          this.form.postal_code = address.long_name;
        }
        if (address.types[0] === "route") {
          this.form.place_name = address.long_name;
        }
      });

      if (place.name != undefined) {
        this.form.label = place.name;
      }
      this.form.place_detail = JSON.stringify(place);
      this.form.address = place.formatted_address;
      //this.form.place_name = place.name;
      this.form.place_id = place.place_id;
      this.form.lat = place.geometry.location.lat();
      this.form.lng = place.geometry.location.lng();
      this.form.remark = "";
    },
  },
};
</script>
<style scoped>
.box-input {
  padding: 12px;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.24);
  background-color: rgba(0, 0, 0, 0.02) !important;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}
.overlay-marker {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.map-layout {
  margin: 0 -16px 16px !important;
}
</style>